import { HTTP_INTERCEPTORS, HttpClientModule, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { APP_INITIALIZER, Injectable, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DevExtremeModule, DxButtonModule } from 'devextreme-angular';
import { Observable } from 'rxjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfigService } from './services/config-service';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';

const apiKeyHeaderName = 'X-Api-Key';

@Injectable({
	providedIn: 'root',
})

export class AuthInterceptorService implements HttpInterceptor {
	// This angular seems to bug out and construct this providedIn: 'root' twice. Losing
	// its state between lifecyles... Might be related to lazy modules.
	private set token(token: string) {
		window['x-as-token'] = token;
	}

	private get token() {
		return window['x-as-token']
	}

	constructor() {
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (this.token) {
			req = req.clone({
				headers: req.headers.set(apiKeyHeaderName, this.token),
			});
		} else {
			console.error(`No token set`);
		}
		return next.handle(req);
	}

	public setToken(token: string) {
		this.token = token;
	}

	public getToken() {
		return this.token;
	}

	public buildOdataSource(url: string): DataSource {
		return new DataSource({
			store: new ODataStore({
				version: 4,
				url: url,
				beforeSend: (request: any) => {
					const token = this.token;
					if (token) {
						request.headers[apiKeyHeaderName] = token;
					}
				}
			}),
		});
	}
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DevExtremeModule,
    DxButtonModule,
    HttpClientModule
  ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfigurations,
      deps: [ConfigService], // dependancy
      multi: true
    },
	{
		provide: HTTP_INTERCEPTORS,
		useClass: AuthInterceptorService,
		multi: true,
	}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function loadConfigurations(configService: ConfigService) {
  return () => configService.loadConfig();
}